import { render, staticRenderFns } from "./PremiumContractModal.vue?vue&type=template&id=ac05b9dc"
import script from "./PremiumContractModal.vue?vue&type=script&lang=js"
export * from "./PremiumContractModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports